import script from "./CvrUploadStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CvrUploadStatus.vue?vue&type=script&setup=true&lang=js"

import "./CvrUploadStatus.vue?vue&type=style&index=0&id=66732317&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66732317"]])

export default __exports__